import React from 'react';

const VacantRooms= () => {

    return (
        <>
            <div className="container-dashboard">
                This is Vacant Rooms Page
            </div>
        </>
    )
};

export default VacantRooms;